var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"section docScroll mt-6",attrs:{"id":"tokenization"}},[_c('SectionColumn',{attrs:{"type":"left","title":"Tokenization","content":_vm.contentCol}}),_c('SectionColumn',{attrs:{"type":"right","content":_vm.contentRightCol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }